import { TooltipConfigModel } from './tooltip-config.model';

export class TooltipConfig {
  public static productConfig: TooltipConfigModel = {
    desktop: 15,
    smallDesktopList: 10,
    other: 8,
  };
  public static productTypeConfig: TooltipConfigModel = {
    desktop: 17,
    smallDesktopList: 10,
    other: 8,
  };
  public static placeConfig: TooltipConfigModel = {
    desktopList: 25,
    desktop: 15,
    smallDesktopList: 9,
    smallDesktop: 8,
    tabletLandscapeList: 7,
    tabletLandscape: 104,
    tabletPortrait: 59,
    mobile: 9,
    other: 20,
  };

  public static getTooltipSmallDesktop(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.smallDesktop
        ? `${text.substring(0, tooltipConfig.smallDesktop)}...`
        : text;
    return text;
  }

  public static getTooltipSmallDesktopList(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.smallDesktopList
        ? `${text.substring(0, tooltipConfig.smallDesktopList)}...`
        : text;
    return text;
  }
  public static getTooltipMobileList(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.mobile
        ? `${text.substring(0, tooltipConfig.mobile)}...`
        : text;
    return text;
  }
  public static getTooltipOther(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.other
        ? `${text.substring(0, tooltipConfig.other)}...`
        : text;
    return text;
  }
  public static getTooltipDesktop(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.desktop
        ? `${text.substring(0, tooltipConfig.desktop)}...`
        : text;
    return text;
  }

  public static getTooltipDesktopList(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.desktopList
        ? `${text.substring(0, tooltipConfig.desktopList)}...`
        : text;
    return text;
  }

  public static getTooltipTabletLandscapeList(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.tabletLandscapeList
        ? `${text.substring(0, tooltipConfig.tabletLandscapeList)}...`
        : text;
    return text;
  }

  public static getTooltipTabletLandscape(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.tabletLandscape
        ? `${text.substring(0, tooltipConfig.tabletLandscape)}...`
        : text;
    return text;
  }
  public static getTooltipTabletPortrait(
    text: string,
    tooltipConfig: TooltipConfigModel,
  ) {
    if (text)
      return text.length > tooltipConfig.tabletPortrait
        ? `${text.substring(0, tooltipConfig.tabletPortrait)}...`
        : text;
    return text;
  }
}
